<template>
  <div class="recharge">
    <PageHeader :title="$t('充币')" url="/myassets"></PageHeader>

    <section class="content_auto">
      <div class="currency-type">
        <h2 class="currency-type-title">{{ $t('币种') }}</h2>
        <Select
          v-model="coinId"
          style="width:480px;"
          :placeholder="$t('请选择币种')"
          size="large"
        >
          <Option v-for="coin in coinList" :value="coin.id" :key="coin.name">
            {{ coin.name.toUpperCase() }}
          </Option>
        </Select>
      </div>

      <!-- 链名称 - 开始 -->
      <div v-if="chainList.length" class="chain-name">
        <h2 class="currency-type-title" style="margin-top: 10px;">
          {{ $t('链名称') }}
        </h2>
        <span
          v-for="chain in chainList"
          :key="chain.id"
          class="chain-name-item"
          :class="chain == currentChain ? 'chain-name-item-active' : ''"
          @click="switchChain(chain)"
        >
          {{ chain.name.toUpperCase() }}
        </span>
      </div>
      <!-- 链名称 - 结束 -->

      <!-- 充币地址 - 开始 -->
      <div v-if="chainData && chainData.address" class="recharge-address">
        <h2 class="recharge-address-title">{{ $t('充币地址') }}</h2>
        <div class="recharge-address-text">
          <span>
            {{ chainData.address }}
          </span>
          <span class="copy-btn" @click="handleCopy">
            {{ $t('复制') }}
          </span>
        </div>
        <div v-if="qrcode" class="recharge-address-qrcode">
          <img :src="qrcode" :alt="$t('充币')" />
        </div>
      </div>
      <!-- 充币地址 - 结束 -->

      <h2 class="recharge-log-title">
        <span>{{ $t('充币记录') }}</span>
      </h2>

      <table class="recharge-log-table">
        <tr>
          <th>{{ $t('时间') }}</th>
          <!-- <th>{{ $t('充币地址') }}</th> -->
          <th>{{ $t('币种') }}</th>
          <th>{{ $t('充币数量') }}</th>
          <th>{{ $t('充币状态') }}</th>
        </tr>
      </table>

      <table v-loading="loading" class="recharge-log-table">
        <tr v-for="log in rechargeLogList" :key="log.id">
          <td>{{ log.time }}</td>
          <!-- <td>{{ log.sourceAddress }}</td>-->
          <td>{{ log.coinCode }}</td>
          <td>{{ log.num }}</td>
          <td>{{ log.states }}</td>
        </tr>
      </table>

      <NoData
        v-if="!rechargeLogList.length"
        height="200px"
        sceneType="day"
      ></NoData>
      <Page
        size="small"
        class-name="page-con"
        v-else
        :current="page.current"
        :total="page.total"
        :page-size="7"
        @on-change="changePage"
      />
    </section>
  </div>
</template>

<script>
import {
  fetchAllCoins,
  ajax_getRechargeAddress,
  ajax_getRechargeLog
} from '@/api/assets'
import { copyText } from '@/utils'
import QrCode from 'qrcode'

export default {
  name: 'Recharge',
  data() {
    return {
      loading: false,
      currentChain: null, // 当前链信息
      coinList: [],
      coinId: '', // 币种Id，该页面主要根据币种展示充币链接
      chainData: {},
      qrcode: '',
      rechargeLogList: [], // 充币记录
      page: {
        current: 1,
        total: 0
      }
    }
  },
  computed: {
    // 当前币种
    currentCoin() {
      return this.coinList.find((coin) => coin.id === this.coinId)
    },
    // 当前币种支持的链
    chainList() {
      if (this.currentCoin) {
        return this.currentCoin.chains
      }
      return []
    }
  },
  watch: {
    coinId() {
      this.currentChain = this.currentCoin.chains[0]
      this.page = {
        current: 1,
        total: 0
      }
      this.getRechargeLog(0)
    },
    currentChain: {
      async handler(newVal) {
        this.chainData = {}
        this.qrcode = ''
        if (!newVal) {
          return
        }
        const { data } = await ajax_getRechargeAddress({
          chain: newVal.name
        })
        this.chainData = data
        if (data.address) {
          this.qrcode = await QrCode.toDataURL(data.address, {
            width: 148,
            margin: 4,
            scale: 3
          })
        } else {
          this.qrcode = ''
        }
      },
      immediate: true
    }
  },
  async mounted() {
    await this.getRechagableCoinList()
    this.getRechargeLog(0)
  },
  methods: {
    handleCopy() {
      copyText(this.chainData.address)
      this.$notify.success({
        title: this.$t('复制成功'),
        duration: 3000,
        offset: 100
      })
    },
    changePage(start) {
      this.getRechargeLog(start - 1)
    },
    async getRechagableCoinList() {
      const coinList = await fetchAllCoins()
      this.coinList = coinList.filter((item) => item.isRecharge === 'S')

      const { coinName } = this.$route.query
      if (coinName) {
        this.coinId = this.coinList.find(
          (item) => item.name.toLowerCase() === coinName.toLowerCase()
        ).id
      }
    },
    async getRechargeLog(start) {
      this.loading = true
      try {
        const { count, item } = await ajax_getRechargeLog({
          coinId: this.coinId,
          start
        })
        this.page.total = count
        this.rechargeLogList = item
      } catch {
        this.page.total = 0
        this.rechargeLogList = []
      } finally {
        this.loading = false
      }
    },
    copyRechargeAddress(addressStr) {
      copyText(addressStr)
      this.$notify({
        type: 'success',
        title: '复制成功',
        duration: 1500,
        offset: 100
      })
    },
    switchChain(chain) {
      if (this.currentChain === chain) return
      this.currentChain = chain
    }
  }
}
</script>
<style scoped lang="less">
.recharge-title {
  font-size: 24px;
  font-weight: 500;
  padding: 60px 0 20px;
}

.currency-type-title {
  color: #333333;
  font-size: 14px;
  margin-bottom: 12px;
}

.money-type-recommend {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  margin-top: 10px;
}

.money-type-recommend a {
  width: 60px;
  height: 30px;
  background: #f5f6fa;
  margin-right: 10px;
  color: #333333;
  font-size: 16px;
  text-align: center;
  line-height: 30px;
}

.recharge-log-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 50px 0 14px;

  span {
    font-size: 16px;
    color: #333333;
  }

  a {
    font-size: 14px;
    color: #42b3fa;
  }
}

.recharge-log-table {
  .table-base(@w:100%);
  th,
  td {
    width: 25%;
  }
}

.recharge-address-box {
  width: 658px;
}

.recharge-address-title {
  font-size: 14px;
  color: #333333;
  margin: 20px 0 10px;
}

.recharge-address-text {
  width: 480px;
  display: flex;
  justify-content: space-between;
  height: 44px;
  line-height: 44px;
  padding-left: 10px;
  padding-right: 10px;
  background: #f5fafe;
  color: #333333;
  font-size: 16px;
  word-break: break-word;
  word-wrap: break-word;

  .copy-btn {
    color: #42b3fa;
    cursor: pointer;
    &:hover {
      opacity: 0.6;
    }
  }
}

.recharge-tip-ul {
  margin-top: 40px;
}

.recharge-tip {
  color: #999;
  font-size: 12px;
  list-style: none;
  margin-bottom: 10px;
}

.qrcode {
  display: block;
  width: 152px;
  height: 152px;
}

/deep/ .page-con {
  .page-base();
  margin: 50px auto 200px;
}

.err-tip {
  color: #ff3f4a;
  margin-top: 20px;
}

.chain-name-item {
  padding: 7px 15px;
  background: #f8f8f8;
  color: #333;
  border-radius: 2px;
  cursor: pointer;
  margin-right: 10px;
  border: 1px solid transparent;
}

.chain-name-item-active {
  border-color: #42b3fa;
  color: #42b3fa;
  background: #fff;
}

.no-data {
  text-align: center;
}
</style>
